export const IS_SSR = typeof window === 'undefined'

export const DefaultDateFormat = 'dd/MM/yyyy'
